<template>
	<div>
		<subscribe-account v-if="SubscribeForm"></subscribe-account>
	    <div v-else>
	        <div class="mainTitle text-center my-3">
	            <h2 class="mb-3">{{$t('toolbox_tradeToolbox')}}</h2>
	        </div>
	        <div class="maxContainer border traderBox whiteBG radius px-md-4 py-md-4 py-xs-3 mb-3">
	        	<div class="row justify-content-center">
	        	 <div class="col-12 col-md-10 midMob">	
		        	<div class="row align-items-center">
						<div class="col-12 col-md-6 text-center">
							<div class="mb-2">
								<img src="../../../../static/fxView/images/boxTool-Design.svg" alt="Email Support" class="mtImg-svg">
							</div> 
							<!-- <div class="downloadBox-tool mb-0">
							 	<h5 class="m-0">
							 		<a href="https://fxview.com/trader-tool-box" class="prism_btn btn_xs  clk" target="_blank">{{$t('toolbox_moreAboutTradeToolbox')}}  </a>
							 	</h5>
							</div> -->
						</div>
					    <div class="col-12 col-md-6">
						<p>{{$t('toolbox_tradeToolMsz1')}} <a  :href="$env_var.traderToolBox"  target="_blank"> {{$t('toolknowMore')}}</a></p>

						<p>{{$t('tools_downloa')}} 
							<!-- <a class="LinkUnderline" href="https://www.fxbluelabs.com/downloads/fxview/FXView-MT4-Apps.20200724.zip" > {{$t('MT4Demo')}}</a> {{$t('toolor')}}  -->
							<a class="LinkUnderline" href="https://www.fxbluelabs.com/downloads/fxview/FXView-MT5-Apps.20200724.zip" > {{$t('MT5Demo')}}</a></p>

						<div class="text-center">
							<!-- <div class="mt-4 d-flex  align-item-center justify-content-start"> 
								<a href="https://www.fxbluelabs.com/downloads/fxview/FXView-MT4-Apps.20200724.zip" class="prism_btn darkBG btn_sm mr-md-3 mb-3">{{$t('DownloadMT4')}} </a>
								<a href="https://www.fxbluelabs.com/downloads/fxview/FXView-MT5-Apps.20200724.zip" class="prism_btn secndrybtn btn_sm  mr-md-3 mb-3">{{$t('DownloadMT5')}} </a> 
							</div> -->
							<a href="#" class="prism_btn btn_sm mr-md-3" style="position: relative; ;" @click.prevent="SubscribeForm = true">{{$t('Subscribe for Live Account')}} </a>
						</div>
					  </div>
				     </div>
				  </div>
		  	    </div>
		  	</div>
		  	<div class="maxContainer border traderBox whiteBG radius px-md-4 py-md-4 py-xs-3 mb-3"> 
		  		
				<div class="downloadT">
					<h5 class="mb-1">{{$t('toolbox_howtoinstall')}}</h5>
					<!-- <p>{{$t('useTraderToolbox')}}</p> -->
					<!-- <p class="m-0">{{$t('HowInstallTraderToolbox')}}</p> -->
					<div class="row">
					<div class="col-12 col-md-6">		
					<ul class="listing py-3 px-1">
					    <li> {{$t('toolbox_loginFxViewmt45')}}</li>
					    <li>{{$t('toolbox_ToolboxApplication')}}</li>
					    <li>{{$t('toolbox_FxviewMT45installation')}}</li>
					    <li>{{$t('toolbox_allowDdlImports')}}</li>
					    <li>{{$t('toolbox_RestartFxviewMT45')}}</li>
					  </ul>
					</div> 
				   </div>
				</div>
				
			</div>
		  	<div class="maxContainer">
				<div class="mainTitle text-center mt-4 mb-3"><h3>{{$t('toolbox_WhatYouGet')}}</h3></div>
				<div class="border traderBox whiteBG radius px-md-4 py-md-4 py-xs-3 mb-3">
					<div class="row">
						<div class="col-12 col-md-6 mobTop"> 
					  		<h5 class="mb-3 text-center">{{$t('toolbox_IndicatorPackage')}}</h5>
						  <ul class="listing toolBox-app d-flex flex-wrap">
						    <li>{{$t('toolbox_Minichart')}}</li>
						    <li>{{$t('toolbox_PivotPoints')}}</li>
						    <li>{{$t('toolbox_HighsLows')}}</li>
							<li>{{$t('toolbox_Renkobars')}}</li>
							<li>{{$t('toolbox_ChartGroup')}}</li>
							<li>{{$t('toolbox_SymbolInfo')}}</li>
							<li>{{$t('toolbox_Gravity')}}</li>
							<li>{{$t('toolbox_Chart_in_Chart')}}</li>
							<li>{{$t('toolbox_PeriodConverter')}}</li>
							<li>{{$t('toolbox_Magnifier')}}</li>
							<li>{{$t('toolbox_OrderHistory')}}</li>
							<li>{{$t('toolbox_FreehandDrawing')}}</li>
							<li>{{$t('toolbox_BarChanger')}}</li>
							<li>{{$t('toolbox_KeltnerChannel')}}</li>
							<li>{{$t('toolbox_DonchianChannel')}}</li>
							<li>{{$t('toolbox_CandleCountdown')}}</li>
							<li>{{$t('toolbox_LinearRegression')}}</li>
						  </ul>
						</div>
						<div class="col-12 col-md-6"> 
						  	<h5 class="mb-3 text-center">{{$t('toolbox_TraderToolboxApp')}}</h5>
							<ul class="listing toolBox-app d-flex flex-wrap">
							    <li>{{$t('toolbox_TradeTerminal')}}</li>
							    <li>{{$t('toolbox_MiniTerminal')}} </li>
							    <li>{{$t('toolbox_AlarmsManager')}} </li>
							    <li>{{$t('toolbox_ExcelRTD')}}</li>
							    <li>{{$t('toolbox_Connect')}} </li>
							    <li>{{$t('toolbox_SentimentTrader')}}</li>
							    <li>{{$t('toolbox_SessionMap')}} </li>
							    <li>{{$t('toolbox_MarketManager')}} </li>
							    <li>{{$t('toolbox_CorrelationMatrix')}}</li>
							    <li>{{$t('toolbox_CorrelationTrader')}}</li>
							    <li>{{$t('toolbox_TickTrader')}}</li>
							    <li>{{$t('toolbox_StealthOrder')}}</li>
							    
							</ul>
						</div>
						

					</div>
				 </div>
				 
			</div>

			<div class="maxContainer border step-bottom-alert mb-5 whiteBG text-center justify-content-center">
				<span class="position-relative l-0"><feather type="alert-circle"></feather></span> 
				<p class="ml-2">{{$t('toolbox_tradeToolboxliveMinDeposit')}} </p>
			</div>
			<div class="mb-2 text-center disclaimer darkBG p-3 row d-flex justify-content-center align-items-center">
				<div class="col-12 col-md-10">
					<small>{{$t('toolbox_DisclaimerAutoChartist')}}</small>
				</div>
			</div>
	    </div>
	</div>
</template>
<script> 
	import subscribe_account from '../manageAccounts/subscribe_account'
	export default {
		name: 'Signal-Centre',
		data() {
			return {
				SubscribeForm : false,
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false
			}
		},
		components:{
			subscribeAccount: subscribe_account
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/tradertool_box.vue